import React from "react";
import clsx from "clsx";
import { RegistrationLayoutRoot } from "./RegistrationLayout.style";

export const RegistrationLayout = ({
  children,
  header,
  containScroll,
}) => (
  <RegistrationLayoutRoot
    className={clsx(
      "fill-width max-full-width flex-y pos-relative",
      containScroll ? "overflow-hide full-height" : "overflow-auto"
    )}
  >
    {header}
    <div
      className={clsx(
        "registration-layout__main flex flex-y flex-1 fill-width pos-relative overflow-hide",
        containScroll && "full-height"
      )}
    >
      {children}
    </div>
  </RegistrationLayoutRoot>
);
